export const API_TYPE = {
  CUSTOM: 'CUSTOM',
  ROES: 'ROES',
  SELF_FULFILLMENT: 'SELF_FULFILLMENT',
  RICHMOND: 'RICHMOND',
};
